import React from "react";
import {WidgetProps} from "./widget";
import {Select} from "antd";
import {useTranslate} from "../../../../../../hooks/translate.hook";
export const BooleanWidget: React.FC<WidgetProps> = ({onChange, value}) => {

    const t = useTranslate();

    return (
        <Select
            placeholder={t("FILTER.VALUE")}
            onChange={v => onChange([v as string])}
            value={value[0]}
            style={{width: '100%'}}
        >
            <Select.Option value={"1"}>Yes</Select.Option>
            <Select.Option value={"0"}>No</Select.Option>
        </Select>
    )
}